module.exports = __webpack_public_path__ + "img/upload_bg_01.681aa847.png";